import React, {useState, useEffect} from "react"
import {formatTextTestIds} from "@next/utils"
import {
    CloseIcon,
    CloseIconButton,
    Tooltip,
    TooltipArrowShadow,
    TooltipArrowNoShadow,
    TooltipBody,
    TooltipTerms,
    TooltipTitle,
    TooltipTitleWrapper,
    TooltipWrapper,
} from "./components"
import connect from "./connect"
import env from "../../config/env"
import {featAvailable, featBackInStock, featDeliverBy} from "../../config/constants"
import {TextModel} from "../../models/Text"

interface TooltipProps {
    handleTooltipClose: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    facetType: string
    text: TextModel
    siteUrl: string
}

const TooltipComponent = ({handleTooltipClose, facetType, text, siteUrl}: TooltipProps) => {
    const [showTermsOfService, setShowTermsOfService] = useState<boolean>(false)
    const [tooltipTitle, setTooltipTitle] = useState<string>("")
    const [tooltipBodyText, setTooltipBodyText] = useState<string>("")

    useEffect(() => {
        if (facetType === featAvailable || facetType === featDeliverBy) setShowTermsOfService(true)

        switch (facetType) {
            case featAvailable:
                setTooltipTitle("In Stock")
                setTooltipBodyText(text.labels.tooltipInStock)
                break
            case featDeliverBy:
                setTooltipTitle("Deliver by Christmas")
                setTooltipBodyText(text.labels.tooltipDeliverByChristmas)
                break
            case featBackInStock:
                setTooltipTitle("Back in stock")
                setTooltipBodyText(text.labels.tooltipBackInStock)
                break
            default:
                setTooltipTitle("")
                break
        }
    }, [facetType, text])

    const tooltipNameId = `plp-facet-tooltip-${facetType}`
    const tooltipTitleId = `plp-facet-tooltip-title-${facetType}`
    const tooltipBodyId = `plp-facet-tooltip-body-${facetType}`

    return (
        <Tooltip data-testid={formatTextTestIds(tooltipNameId)}>
            <TooltipArrowShadow />
            <TooltipArrowNoShadow />
            <TooltipWrapper data-testid="plp-facet-tooltip-wrapper">
                <TooltipTitleWrapper>
                    <TooltipTitle data-testid={formatTextTestIds(tooltipTitleId)}>{tooltipTitle}</TooltipTitle>
                    <CloseIconButton data-testid="plp-facet-tooltip-close-button" onClick={e => handleTooltipClose(e)}>
                        <CloseIcon
                            src={`${env.REACT_APP_BLOB_STORAGE_PATH}/icons/shared/next_close-black.svg`}
                            alt="Close Icon"
                            aria-label={`${facetType}-facet-tooltip-close`}
                        />
                    </CloseIconButton>
                </TooltipTitleWrapper>
                <TooltipBody data-testid={formatTextTestIds(tooltipBodyId)}>
                    {tooltipBodyText}
                    {facetType === "feat:deliveryby" ? ` ${new Date().getFullYear()}). ` : ` `}
                    {showTermsOfService && (
                        <span>
                            {text.labels.toolTipTermsAndConditionsStart}
                            <TooltipTerms aria-label={`${facetType}-facet-tooltip-terms`} href={`${siteUrl}/terms`}>
                                {text.labels.toolTipTermsAndConditions}
                            </TooltipTerms>
                            {text.labels.toolTipTermsAndConditionsEnd}
                        </span>
                    )}
                </TooltipBody>
            </TooltipWrapper>
        </Tooltip>
    )
}

export default connect(TooltipComponent)
